module.exports = __webpack_public_path__ + "static/js_bootcamp-179f0bf5a00bd9f1904fc25366f1adab.jpg";